// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"5849ff24","333":"926b912c","337":"7923c461","457":"25bde0ff","551":"0addf331","851":"ecee029e","880":"74cfb03f"}[chunkId] + ".chunk.js";
};